<template>
  <div class="container">
    <div class="left">
      <div class="menu">
        <div @click="go(`/user/base-info`)">
          <span>基本信息</span>
        </div>
        <div class="active">
          <span>安全中心</span>
        </div>
        <div @click="go(`/user/default-corp`)">
          <span>设置默认企业</span>
        </div>
      </div>
    </div>
    <div class="right">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    go(path) {
      this.$router.push(path);
    },
  },
};
</script>
